import axios from "axios";
import { FetchDataRequest, FetchDataResult } from "../../../Common/models/grid";
import { SieveResponse } from "../../../Common/models/sieve";
import {
  getSieveRequestModel,
  mapToFetchDataResult,
} from "../../../Common/utils/sieveRequestModel";
import { FlaggingReason } from "./models/FlaggingReason";

const inFlightMyProjectsRequests = new Map<string, Promise<FetchDataResult>>();

export const getMyProjects = async (
  request: FetchDataRequest
): Promise<FetchDataResult> => {
  const sieveRequest = getSieveRequestModel(request);
  const requestKey = JSON.stringify(sieveRequest);

  const pendingRequest = inFlightMyProjectsRequests.get(requestKey);
  if (pendingRequest) {
    return pendingRequest;
  }

  const requestPromise = (async () => {
  const { data } = await axios.get<SieveResponse>(
    `${window.configuration.apiUrl}api/Projects`,
    { params: sieveRequest }
  );

  const response = mapToFetchDataResult(data);
  return response;
  })();

  inFlightMyProjectsRequests.set(requestKey, requestPromise);

  try {
    return await requestPromise;
  } finally {
    inFlightMyProjectsRequests.delete(requestKey);
  }
};

export const getProjectsCostCenterCount = async (
  projectId: string
): Promise<number> => {
  const { data } = await axios.get<number>(
    `${window.configuration.apiUrl}api/Projects/${projectId}/sameCostCenterCount`
  );

  return data;
};



export const unflagProject = async (
  projectId: string,
  unflag: boolean,
  includeAllWithSameCostCenter: boolean,
  flaggingReason?: FlaggingReason
): Promise<void> => {
  await axios.put(
    `${window.configuration.apiUrl}api/Projects/${projectId}/setFlag`,
    {
      unflag,
      includeAllWithSameCostCenter,
      flaggingReason,
    }
  );
};

export const toggleLock = async (
  projectId: string,
  isLocked: boolean
): Promise<void> => {
  await axios.put(
    `${window.configuration.apiUrl}api/Projects/${projectId}/toggleLock`,
    {
      isLocked
    }
  );
};